import $ from 'jquery';
import logout from 'modules/logout';

export default function(selector) {
  $(selector).on('click', function(e) {
    e.preventDefault();
    logout();
  });
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/header-logout.js